import React from 'react'
import { Button, Form, Spinner } from 'react-bootstrap'

const TrackedLinkCreateForm = ({
  linkName,
  setLinkName,
  handleCreateLink,
  isCreatingLink,
  isLoadingLinks,
  trackedLinksCount
}) => {
  return (
    <Form onSubmit={handleCreateLink}>
      <Form.Group className="mb-3">
        <Form.Label className="mb-1" style={{ fontSize: '0.875rem' }}>
          Link name
        </Form.Label>
        <div className="d-flex align-items-end">
          <Form.Control
            type="text"
            placeholder='e.g. "Marketing campaign, or salesprospect@example.com"'
            value={linkName}
            onChange={(e) => setLinkName(e.target.value)}
            className="me-3"
            required
            disabled={isCreatingLink || isLoadingLinks}
          />
          <Button
            variant="primary"
            type="submit"
            disabled={!linkName.trim() || trackedLinksCount >= 20 || isCreatingLink || isLoadingLinks}
            style={{
              whiteSpace: 'nowrap'
            }}
          >
            {isCreatingLink ? <Spinner animation="border" size="sm" /> : 'Create link'}
          </Button>
        </div>
        {trackedLinksCount >= 20 ? (
          <div className="mt-1 ms-1 text-danger small">You have reached the maximum number of unique links.</div>
        ) : null}
      </Form.Group>
    </Form>
  )
}

export default TrackedLinkCreateForm
